import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { MeterPerSecond } from "./velocity";
/** The metric unit for acceleration quantities ( <code>m/s²</code> ). */
export var MeterPerSquareSecond = UnitDivide.velocityBySecond("MeterPerSquareSecond", MeterPerSecond, BaseUnits.Second);
//# sourceMappingURL=acceleration.js.map